import {
    fetchChallengeList,
    fetchInvitedChallenges,
    fetchChallengeQuizList,
    fetchChallengeQuizParticipation,
    saveQuizParticipation,
    saveNewParticipation,
    updateParticipation,
    deleteParticipation
} from '../../services/challengeService';
import { getCurrentUserId } from '../../utils/userStorage';
import { isLocalSync } from '../../services/challengeSource';

export const SET_CHALLENGE_LIST = 'SET_CHALLENGE_LIST';
export const SET_CHALLENGE_QUIZ_LIST = 'SET_CHALLENGE_QUIZ_LIST';
export const SET_QUIZ_CORRECT_RESULT = 'SET_QUIZ_CORRECT_RESULT';
export const SAVE_QUIZ_PARTICIPATION_START = 'SAVE_QUIZ_PARTICIPATION_START';
export const SAVE_QUIZ_PARTICIPATION_SUCCESS = 'SAVE_QUIZ_PARTICIPATION_SUCCESS';
export const SAVE_QUIZ_PARTICIPATION_FAILURE = 'SAVE_QUIZ_PARTICIPATION_FAILURE';

// 로그아웃 시 챌린지 데이터 초기화
export const CLEAR_CHALLENGE_DATA = 'CLEAR_CHALLENGE_DATA';

export const setChallengeList = (list) => ({ type: SET_CHALLENGE_LIST, payload: list });
export const setChallengeQuizList = (challengeId, quizList) => ({
    type: SET_CHALLENGE_QUIZ_LIST,
    payload: { challengeId, quizList }
});
export const setQuizCorrectResult = (challengeId, quizNo, correctResult) => ({
    type: SET_QUIZ_CORRECT_RESULT,
    payload: { challengeId, quizNo, correctResult }
});

export const setQuizCorrectResultError = (challengeId, quizNo, error) => ({
    type: SET_QUIZ_CORRECT_RESULT,
    payload: { challengeId, quizNo, correctResult: null, error }
});

export const clearQuizCorrectResults = (challengeId) => ({
    type: 'CLEAR_QUIZ_CORRECT_RESULTS',
    payload: { challengeId }
});

export const clearQuizCorrectResultError = (challengeId, quizNo) => ({
    type: 'CLEAR_QUIZ_CORRECT_RESULT_ERROR',
    payload: { challengeId, quizNo }
});

// 챌린지 목록 조회 (전체 목록을 한 번에)
export const loadChallengeList = () => async (dispatch, getState) => {
    try {
        console.log('=== 전체 챌린지 목록 로드 시작 ===');

        const response = await fetchChallengeList();
        console.log('API 응답:', response);

        // 응답이 직접 배열인 경우와 { qryChallengeLst: [] } 형태인 경우 모두 처리
        let challengeData = [];
        if (Array.isArray(response)) {
            // 직접 배열인 경우
            challengeData = response;
        } else if (response && response.qryChallengeLst) {
            // 객체 안의 qryChallengeLst 배열인 경우
            challengeData = response.qryChallengeLst;
        }

        if (challengeData && challengeData.length > 0) {
            // 첫 번째 챌린지의 모든 필드 확인 (디버깅용)
            if (challengeData[0]) {
                console.log('🔍 코어서버 챌린지 원본 필드:', Object.keys(challengeData[0]));
                console.log('🔍 코어서버 챌린지 원본 데이터:', challengeData[0]);
            }

            const challengeList = challengeData.map(challenge => ({
                QRY_CHALLENGE_ID: challenge.qryChallengeId,
                CHALLENGE_NM: challenge.qryChallengeNm || challenge.challengeNm,
                CHALLENGE_LEVEL_DCD: challenge.challengeLevelDcd,
                // 튜닝 챌린지의 DBMS(2026-10-05) — 없으면 Oracle(예전 챌린지는 전부 Oracle 이다)
                DBMS: challenge.challengeDbms || null,
                // 챌린지 속성 JSON(종류·DBMS) — utils/challengeAttr 가 읽는다. QBase 는 vw_qry_challenge.challenge_attr_cn
                CHALLENGE_ATTR_CN: challenge.challengeAttrCn ?? null,
                BGNG_DT: challenge.startDt || challenge.bgngDt,
                END_DT: challenge.endDt,
                PUBLIC_YN: challenge.openYn,
                MGR_USRID: challenge.mgrUsrid || challenge.managerUsrid || challenge.MGR_USRID, // 담당자 ID 추가
                IS_INVITED: false // 일반 챌린지
            }));

            console.log('전체 챌린지 목록 매핑 완료:', challengeList.length + '개');
            console.log('매핑된 챌린지 목록:', challengeList);

            // 현재 Redux 상태 확인
            const currentState = getState();
            console.log('현재 Redux 챌린지 목록:', currentState.challenge.challengeList);

            dispatch(setChallengeList(challengeList));
        } else {
            console.log('챌린지 목록 응답이 비어있음:', response);
        }
    } catch (error) {
        console.error('챌린지 목록 로드 실패:', error);
        console.error('에러 상세:', error.response?.data);
    }
};

// 초대된 챌린지 목록 조회 및 기존 목록과 병합
export const loadInvitedChallenges = (groupId, groupName) => async (dispatch, getState) => {
    try {
        console.log('초대된 챌린지 목록 로드:', { groupId, groupName });

        // 1. 일반 챌린지 목록이 없으면 먼저 로드
        const currentState = getState();
        if (!currentState.challenge.challengeList || currentState.challenge.challengeList.length === 0) {
            await dispatch(loadChallengeList());
        }

        // 2. 초대된 챌린지 목록 로드 (groupName 우선 사용, 없으면 groupId 사용)
        const groupIdentifier = groupName || groupId;
        if (groupIdentifier) {
            const invitedResponse = await fetchInvitedChallenges(groupIdentifier);

            if (invitedResponse && invitedResponse.success && invitedResponse.invitedChallenges) {
                const invitedChallenges = invitedResponse.invitedChallenges.map(challenge => ({
                    QRY_CHALLENGE_ID: challenge.qryChallengeId,
                    CHALLENGE_NM: challenge.challengeNm,
                    CHALLENGE_LEVEL_DCD: challenge.challengeLevelDcd,
                    DBMS: challenge.challengeDbms || null,
                // 챌린지 속성 JSON(종류·DBMS) — utils/challengeAttr 가 읽는다. QBase 는 vw_qry_challenge.challenge_attr_cn
                CHALLENGE_ATTR_CN: challenge.challengeAttrCn ?? null,
                    BGNG_DT: challenge.bgngDt,
                    END_DT: challenge.endDt,
                    PUBLIC_YN: challenge.openYn || challenge.open_yn,
                    MGR_USRID: challenge.mgrUsrid || challenge.managerUsrid || challenge.MGR_USRID, // 담당자 ID 추가
                    IS_INVITED: true // 초대된 챌린지 마킹
                }));

                console.log('초대된 챌린지 매핑 완료:', invitedChallenges.length + '개');

                // 3. 기존 목록과 병합 (중복 제거)
                const currentState = getState();
                const existingChallenges = currentState.challenge.challengeList || [];

                const mergedChallenges = [...existingChallenges];

                invitedChallenges.forEach(invited => {
                    const existingIndex = mergedChallenges.findIndex(existing =>
                        existing.QRY_CHALLENGE_ID === invited.QRY_CHALLENGE_ID
                    );

                    if (existingIndex === -1) {
                        // 새로운 챌린지 추가
                        mergedChallenges.push(invited);
                    } else {
                        // 기존 챌린지를 초대된 것으로 업데이트
                        mergedChallenges[existingIndex] = { ...mergedChallenges[existingIndex], IS_INVITED: true };
                    }
                });

                console.log('챌린지 목록 병합 완료:', mergedChallenges.length + '개');
                dispatch(setChallengeList(mergedChallenges));
            }
        }
    } catch (error) {
        console.error('초대된 챌린지 목록 로드 실패:', error);
    }
};

// 챌린지 퀴즈 목록 조회 (Redux 상태 확인 후 API 호출)
export const loadChallengeQuizList = (challengeId, forceRefresh = false) => async (dispatch, getState) => {
    try {
        // Redux 상태에서 기존 데이터 확인
        const state = getState();
        const existingQuizList = state.challenge.challengeQuizMap[challengeId];

        // 강제 새로고침이 아니고 이미 데이터가 있으면 API 호출 생략
        // undefined가 아니고 (이미 한번 API 호출했고) 데이터가 있으면 생략
        if (!forceRefresh && existingQuizList !== undefined && existingQuizList.length > 0) {
            console.log('퀴즈 목록 Redux 상태에서 사용:', challengeId, '데이터 개수:', existingQuizList.length);
            return;
        }

        console.log('퀴즈 목록 API 호출 시작:', challengeId, forceRefresh ? '(강제 새로고침)' : '(상태 없음)');
        const response = await fetchChallengeQuizList(challengeId);
        console.log('=== 퀴즈 목록 API 전체 응답 ===');
        console.log('response:', response);
        console.log('response 타입:', typeof response);
        console.log('response 키들:', Object.keys(response || {}));

        // qryChallengeQuizLst 배열에서 데이터 추출
        const dataArray = response.qryChallengeQuizLst || [];
        console.log('=== 퀴즈 데이터 추출 ===');
        console.log('dataArray:', dataArray);
        console.log('dataArray 길이:', dataArray.length);
        console.log('dataArray 타입:', typeof dataArray);
        console.log('dataArray가 배열인가?', Array.isArray(dataArray));

        if (dataArray.length > 0) {
            console.log('🔍 [퀴즈 데이터 구조] 전체 퀴즈 개수:', dataArray.length);
            dataArray.forEach((quiz, index) => {
                console.log(`🔍 [퀴즈 ${index}] 키 목록:`, Object.keys(quiz));
                if (quiz.addCransVerifCn) {
                    console.log(`🔍 [퀴즈 ${index}] addCransVerifCn 존재:`, quiz.addCransVerifCn.substring(0, 50) + '...');
                }
            });
        }

        const mappedData = dataArray.map(item => {
            const mapped = {
                QUIZ_NO: item.quizNo,
                QUIZ_DC: item.quizDc || null,
                QUIZ_HINT: item.quizHint || null,
                QUIZ_TCD: item.quizTcd || null,
                QRY_CHALLENGE_ID: item.qryChallengeId,
                CRANS_SQL_CN: item.cransSqlCn || null,
                CRANS_RST_CN: item.cransRstCn || null,
                ADD_CRANS_VERIF_CN: item.addCransVerifCn || null,
                ATCH_FILE_LST_CN: item.atchFileLstCn || null
            };
            return mapped;
        });

        console.log('=== 매핑된 퀴즈 데이터 ===');
        console.log('mappedData:', mappedData);
        console.log('mappedData 길이:', mappedData.length);

        dispatch({
            type: 'SET_CHALLENGE_QUIZ_LIST',
            payload: { challengeId, quizList: mappedData }
        });
    } catch (error) {
        console.error('챌린지 퀴즈 목록 로드 실패:', error);
        console.error('에러 상세:', error.response?.data);
        dispatch({
            type: 'SET_CHALLENGE_QUIZ_LIST',
            payload: { challengeId, quizList: [] }
        });
    }
};

// 챌린지 퀴즈 참여 정보 조회 (Redux 상태 확인 후 API 호출)
export const loadChallengeQuizParticipation = (challengeId, forceRefresh = false) => async (dispatch, getState) => {
    try {
        const state = getState();

        // Redux 상태에서 기존 데이터 확인
        const existingParticipationList = state.challenge.challengeParticipationMap[challengeId];

        // 강제 새로고침이 아니고 이미 데이터가 있으면 API 호출 생략
        // undefined가 아니고 (이미 한번 API 호출했고) 데이터가 있으면 생략
        if (!forceRefresh && existingParticipationList !== undefined && existingParticipationList.length > 0) {
            console.log('참여 정보 Redux 상태에서 사용:', challengeId, '데이터 개수:', existingParticipationList.length);
            return;
        }

        console.log('=== participation 데이터 로드 시작 ===');
        console.log('challengeId:', challengeId, forceRefresh ? '(강제 새로고침)' : '(상태 없음)');

        // 현재 로그인된 사용자 ID 가져오기 (usrid 우선, 대체재로 다른 필드 사용)
        console.log('🔍 [UserID Debug] Redux auth state:', {
            authUser: state.auth?.user,
            usrid: state.auth?.user?.usrid,
            id: state.auth?.user?.id,
            username: state.auth?.user?.username
        });

        const userIdFromStorage = getCurrentUserId();
        console.log('🔍 [UserID Debug] getCurrentUserId():', userIdFromStorage);

        const userId = state.auth?.user?.usrid || state.auth?.user?.id || state.auth?.user?.username || userIdFromStorage;
        console.log('🔍 [UserID Debug] 최종 선택된 사용자 ID:', userId);

        // **로컬 챌린지는 로그인 없이 푼다** (2026-09-19). 이 게이트가 남아 있어서
        // 스탠드얼론에서는 제출이 **저장은 되는데 목록에 안 보였다** — 제출 횟수가 줄지
        // 않고 「내 기록」이 비어, 사용자에게는 저장이 안 된 것으로 보였다.
        // (제출 게이트는 앞서 풀었는데 읽기 쪽을 빠뜨렸다.)
        if (!isLocalSync() && (!userId || userId === 'anonymous')) {
            console.warn('로그인되지 않은 사용자, participation 데이터 로드 생략');
            return;
        }

        const response = await fetchChallengeQuizParticipation(challengeId, userId);
        console.log('📥 participation API 응답:', response);

        // qryChallengeQuizPtcpLst 배열에서 데이터 추출
        const dataArray = response.qryChallengeQuizPtcpLst || [];
        console.log('📦 추출된 participation 데이터 (원본):', dataArray);

        // 참여그룹ID 확인
        console.log('🔍 참여그룹ID 확인 (첫 3개):');
        dataArray.slice(0, 3).forEach((item, index) => {
            console.log(`  [${index}] qryChallengePtcpGrpId:`, item.qryChallengePtcpGrpId, '| usrid:', item.usrid, '| quizNo:', item.quizNo);
        });

        const mappedData = dataArray.map(item => ({
            QRY_CHALLENGE_ID: item.qryChallengeId,
            QUIZ_NO: item.quizNo,
            USRID: item.usrid,
            QRY_CHALLENGE_PTCP_GRP_ID: item.qryChallengePtcpGrpId, // 참여그룹 ID 추가
            SBMSN_DT: item.sbmsnDt,
            SBMSN_SQL_CN: item.sbmsnSqlCn,
            SBMSN_NOT: parseInt(item.sbmsnNot) || 0,  // 제출 횟수 (문자열을 숫자로 변환)
            SUCCSS_YN: item.succssYn,
            FAIL_RSN_CN: item.failRsnCn,
            USER_KNME: item.userKnme
        }));

        console.log('✅ 매핑된 participation 데이터:', mappedData);
        console.log('🔍 매핑된 데이터 참여그룹ID 확인 (첫 3개):');
        mappedData.slice(0, 3).forEach((item, index) => {
            console.log(`  [${index}] QRY_CHALLENGE_PTCP_GRP_ID:`, item.QRY_CHALLENGE_PTCP_GRP_ID, '| USRID:', item.USRID, '| QUIZ_NO:', item.QUIZ_NO);
        });
        dispatch({
            type: 'SET_CHALLENGE_QUIZ_PARTICIPATION',
            payload: { challengeId, participationList: mappedData }
        });
    } catch (error) {
        console.error('챌린지 퀴즈 참여 정보 로드 실패:', error);
        console.error('에러 상세:', error.response?.data);
        dispatch({
            type: 'SET_CHALLENGE_QUIZ_PARTICIPATION',
            payload: { challengeId, participationList: [] }
        });
    }
};

// 퀴즈 참여 저장 액션들
export const saveQuizParticipationStart = () => ({
    type: SAVE_QUIZ_PARTICIPATION_START
});

export const saveQuizParticipationSuccess = (result) => ({
    type: SAVE_QUIZ_PARTICIPATION_SUCCESS,
    payload: result
});

export const saveQuizParticipationFailure = (error) => ({
    type: SAVE_QUIZ_PARTICIPATION_FAILURE,
    payload: error
});

/**
 * 퀴즈 참여 저장 (일반 함수)
 */
export const saveQuizParticipationAction = (participationData) => async (dispatch, getState) => {
    try {
        dispatch(saveQuizParticipationStart());
        
        console.log('=== 퀴즈 참여 저장 액션 시작 ===');
        console.log('참여 데이터:', participationData);
        
        const result = await saveQuizParticipation(participationData);
        
        console.log('퀴즈 참여 저장 성공:', result);
        dispatch(saveQuizParticipationSuccess(result));
        
        // 저장 후 참여 정보를 다시 로드
        if (participationData.challengeId) {
            dispatch(loadChallengeQuizParticipation(participationData.challengeId));
        }
        
        return { success: true, result };
    } catch (error) {
        console.error('퀴즈 참여 저장 실패:', error);
        dispatch(saveQuizParticipationFailure(error.message));
        return { success: false, error: error.message };
    }
};

/**
 * 신규 퀴즈 참여 저장
 */
export const saveNewQuizParticipation = (challengeId, quizId, sql, isCorrect, score = 0) => async (dispatch, getState) => {
    try {
        dispatch(saveQuizParticipationStart());
        
        // 현재 로그인된 사용자 정보 가져오기
        const state = getState();
        const userId = state.auth?.user?.id || state.auth?.user?.username || 'testUser';
        
        console.log('=== 신규 퀴즈 참여 저장 ===');
        console.log('challengeId:', challengeId);
        console.log('quizId:', quizId);
        console.log('userId:', userId);
        console.log('isCorrect:', isCorrect);
        console.log('score:', score);
        
        const result = await saveNewParticipation(challengeId, quizId, userId, sql, isCorrect, score);
        
        console.log('신규 퀴즈 참여 저장 성공:', result);
        dispatch(saveQuizParticipationSuccess(result));
        
        // 저장 후 참여 정보를 다시 로드
        dispatch(loadChallengeQuizParticipation(challengeId));
        
        return { success: true, result };
    } catch (error) {
        console.error('신규 퀴즈 참여 저장 실패:', error);
        dispatch(saveQuizParticipationFailure(error.message));
        return { success: false, error: error.message };
    }
};

/**
 * 퀴즈 참여 정보 수정
 */
export const updateQuizParticipation = (challengeId, quizId, sql, isCorrect, score = 0) => async (dispatch, getState) => {
    try {
        dispatch(saveQuizParticipationStart());
        
        // 현재 로그인된 사용자 정보 가져오기
        const state = getState();
        const userId = state.auth?.user?.id || state.auth?.user?.username || 'testUser';
        
        console.log('=== 퀴즈 참여 정보 수정 ===');
        console.log('challengeId:', challengeId);
        console.log('quizId:', quizId);
        console.log('userId:', userId);
        console.log('isCorrect:', isCorrect);
        console.log('score:', score);
        
        const result = await updateParticipation(challengeId, quizId, userId, sql, isCorrect, score);
        
        console.log('퀴즈 참여 정보 수정 성공:', result);
        dispatch(saveQuizParticipationSuccess(result));
        
        // 수정 후 참여 정보를 다시 로드
        dispatch(loadChallengeQuizParticipation(challengeId));
        
        return { success: true, result };
    } catch (error) {
        console.error('퀴즈 참여 정보 수정 실패:', error);
        dispatch(saveQuizParticipationFailure(error.message));
        return { success: false, error: error.message };
    }
};

/**
 * 퀴즈 참여 정보 삭제
 */
export const deleteQuizParticipation = (challengeId, quizId) => async (dispatch, getState) => {
    try {
        dispatch(saveQuizParticipationStart());
        
        // 현재 로그인된 사용자 정보 가져오기
        const state = getState();
        const userId = state.auth?.user?.id || state.auth?.user?.username || 'testUser';
        
        console.log('=== 퀴즈 참여 정보 삭제 ===');
        console.log('challengeId:', challengeId);
        console.log('quizId:', quizId);
        console.log('userId:', userId);
        
        const result = await deleteParticipation(challengeId, quizId, userId);
        
        console.log('퀴즈 참여 정보 삭제 성공:', result);
        dispatch(saveQuizParticipationSuccess(result));
        
        // 삭제 후 참여 정보를 다시 로드
        dispatch(loadChallengeQuizParticipation(challengeId));
        
        return { success: true, result };
    } catch (error) {
        console.error('퀴즈 참여 정보 삭제 실패:', error);
        dispatch(saveQuizParticipationFailure(error.message));
        return { success: false, error: error.message };
    }
};

// 초대된 챌린지 제거 (참여그룹 해제시)
export const removeInvitedChallenges = () => (dispatch, getState) => {
    try {
        console.log('초대된 챌린지 제거');
        const currentState = getState();
        const existingChallenges = currentState.challenge.challengeList || [];

        // IS_INVITED가 true인 챌린지만 제거하고, 일반 챌린지는 IS_INVITED를 false로 설정
        const filteredChallenges = existingChallenges
            .filter(ch => ch.IS_INVITED !== true || ch.PUBLIC_YN === 'Y') // 초대된 비공개 챌린지만 제거
            .map(ch => ({ ...ch, IS_INVITED: false })); // 남은 챌린지들의 IS_INVITED를 false로 설정

        console.log('초대된 챌린지 제거 완료:', filteredChallenges.length + '개 남음');
        dispatch(setChallengeList(filteredChallenges));
    } catch (error) {
        console.error('초대된 챌린지 제거 실패:', error);
    }
};

/**
 * 로그아웃 시 모든 챌린지 관련 데이터 초기화
 */
export const clearChallengeData = () => ({
    type: CLEAR_CHALLENGE_DATA
}); 